import React, {forwardRef, useEffect, useState} from "react";
import styled from "styled-components";
import useRequestTrackingStyles, {PageTitleDiv, RequestTrackingTable} from "./request-tracking-style";
import {
    _getPolicy,
    _getRequestList,
    _retrieveRequests,
    _storeRequest,
    _storeRequestList
} from "../../store/policy/service";
import {_getLang, _hideSpinner, _showSpinner, _setCpToken} from "../../store/system/service";
import {useHistory, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import moment from "moment";
import useConfig from "../qnect-ui/qnect-config";
import {_getUser} from "../../store/user/service";
import RequestTrackingStatus from "./request-tracking-status";
import MaterialTable from "@material-table/core";
import {
    AddBox,
    ArrowDownward,
    Check,
    ChevronLeft,
    ChevronRight,
    Clear,
    DeleteOutline,
    Edit,
    FilterList,
    FirstPage,
    LastPage,
    Remove,
    SaveAlt,
    Search,
    ViewColumn
} from "@material-ui/icons";
import {_formatDate} from "../../utils/utility";
import ScrollToTopButton from "../ui/scroll-to-top/scroll-to-top";


const StyledRequestNoDiv = styled.div`
    color: #003DA5;
    cursor: pointer;
    
`;

const StyledBreadCrumbDiv = styled.div`
    font-family: Inter-Regular;
    font-size: 12px;
    display: flex;
    & > div:first-child {
        border-bottom: 2px solid rgba(98,112,136,0.4);
    }
    
    & > div {
        border-bottom: 2px solid black;
        padding-bottom: 5px;
        cursor: pointer;
    }
`;

const TitleDiv = styled.div`
    margin-top: 48px;
    font-family: Stag-Medium;
    color: #0A1F44;
    font-size: 32px;
`;

const PolicyDiv = styled.div`
    margin-top: 46px;
    box-sizing: border-box;
    height: 157px;
    width: 1251px;
    border: 1px solid #E1E4E8;
    border-radius: 10px;
    background-color: #FFFFFF;
    box-shadow: 2px 2px 8px 0 rgba(20,40,75,0.2);

    @media (max-width: 1251px) and (min-width: 1024px) {
        width: 100%;
    }
    
    & > div.insideDiv {
        margin-top: 32.5px;
        margin-left: 40.5px;
        width: 1041px;
        display: flex;
        
        & > div {
            flex-basis: 100%;
            display: flex;
            
            & > div.iconDiv {
                margin-right: 25px;
            }   
        }
    }
    
    .normal {
        font-size: 16px;
        font-family: Inter-Regular;
    }
    
    .bold {
        font-size: 20px;
        font-family: Inter-Medium;
    }
    
    div.policyNumberDiv > div:first-child {
        margin-bottom: 5px;
    }
`;

const SubsidiaryTitleDiv = styled.div`
    margin-top: 30px;
    font-family: Stag-Medium;
    font-size: 20px;
    color: #0A1F44;
`;

const TableDiv = styled.div`
    margin-top: 36px;
    font-family: Inter-Semibold;
    font-size: 12px
    
    div.tableTitle {
        font-family: Inter-SemiBold;
        font-size: 16px;
        color: #0A1F44;
    }
`;

const RequestTracking = (props) => {
    const cfg = useConfig(props.lang);
    const history = useHistory();
    const classes = useRequestTrackingStyles(props);
    const [requestList, setRequestList] = useState(props.requestList);

    const tableIcons = {
        Add: forwardRef((props, ref) => <AddBox {...props} ref={ref}/>),
        Check: forwardRef((props, ref) => <Check {...props} ref={ref}/>),
        Clear: forwardRef((props, ref) => <Clear {...props} ref={ref}/>),
        Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref}/>),
        DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref}/>),
        Edit: forwardRef((props, ref) => <Edit {...props} ref={ref}/>),
        Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref}/>),
        Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref}/>),
        FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref}/>),
        LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref}/>),
        NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref}/>),
        PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref}/>),
        ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref}/>),
        Search: forwardRef((props, ref) => <Search {...props} ref={ref}/>),
        SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref}/>),
        ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref}/>),
        ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref}/>)
    };
    const columns = [
        {
            title: 'Date Requested',
            field: 'requestedDate',
            customSort: (val1, val2) => dateSortingFunction(val1, val2, 'requestedDate'),
            render: rowData => _formatDate(rowData.requestedDate)
        },
        {
            title: 'Request No',
            field: 'requestNo',
            render: rowData => <StyledRequestNoDiv onClick={() => requestView(rowData)}>#{rowData.requestNo}</StyledRequestNoDiv>
        },
        {
            title: 'Policy Number',
            field: 'policyNumber'
        },
        {
            title: 'Requester',
            field: 'requesterName'
        },
        {
            title: 'Progress Workflow',
            field: 'status',
            render: rowData => <RequestTrackingStatus status={rowData.status}/>
        }
    ];

    useEffect(() => {
        if (!requestList || requestList.length === 0) {
            props.showSpinner();
            props.retrieveRequests().then((response) => {
                if (response.success) {
                    setRequestList(response.data);
                    props.storeRequestList(response.data);
                    props.setCpToken(response.token);
                }
                props.hideSpinner();
            }, () => {
                console.log('no data');
                props.hideSpinner();
            });
        }

    }, []);

    const dateSortingFunction = (val1, val2, fieldName) => {
        let date1 = moment(val1[fieldName],'DD/MM/YYYY').toDate();
        let date2 = moment(val2[fieldName],'DD/MM/YYYY').toDate();
        return (date2 - date1);
    }

    const requestView = (request) => {
        props.storeRequest(request);
        console.log('request', request);
        history.push("/requestTrackingDetail");
    }

    return (
        <div className={classes.page_container}>

            <PageTitleDiv>
                <span>Request Tracking</span>
            </PageTitleDiv>

            <RequestTrackingTable>
                <MaterialTable columns={columns} data={requestList} title='' icons={tableIcons} />
            </RequestTrackingTable>
            <ScrollToTopButton></ScrollToTopButton>

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: _getUser(state),
        requestList: _getRequestList(state),
        lang: _getLang(state),

    }
}

const mapDispatchToProps = {
    retrieveRequests: _retrieveRequests,
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner,
    storeRequest: _storeRequest,
    storeRequestList: _storeRequestList,
    setCpToken: _setCpToken

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RequestTracking));
